<script>
  import { onMount, afterUpdate } from "svelte";

  import SocialTags from "@Components/SocialTags/index.svelte";

  import HomeContent from "@Pages/Home/content.svelte";

  import FooterMenu from "@Components/FooterMenu/index.svelte";
  import CopyrightFooter from "@Components/CopyrightFooter/index.svelte";

  import { AWSAuth } from "@Services";

  const DEBUG = document.location.protocol === "http:" ? true : false;
  const BID = "'05232021-10001";

  let isVisitor = true;

  export let router = null;

  onMount(async () => {
    console.info("App " + DEBUG + "::" + BID + "::" + router.path);

    AWSAuth.isAnonymous().then(response => {
      isVisitor = response;
    });

    mobiscroll.settings = {
      theme: "d-ns",
      themeVariant: "light",
      lang: "es"
    };

    mobiscroll.page(".free-page", {});
  });
</script>

<style src="./style.scss">

</style>

<SocialTags />
<main id="dnsPage" class="mbsc-grid d-ns-page free-page">
  <HomeContent />
  <footer class="mbsc-row">
    <nav class="mbsc-col-12">
      <FooterMenu />
    </nav>
    <CopyrightFooter />
  </footer>
</main>
